export default "__VITE_ASSET__EpvJrUjd__"